import { render, staticRenderFns } from "./IconListChapers.vue?vue&type=template&id=3e98c5ca&"
import script from "./IconListChapers.vue?vue&type=script&lang=js&"
export * from "./IconListChapers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports